import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";

export class PiggyStageConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(PiggyStageConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(PiggyStageConfig, v);
            }
        );
    }

    constructor() {
        super();

        this._key = "";
        this._name = "";

        this._rewardOnMerge = null;
        this._rewardTrack = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get rewardOnMerge() {
        return this._rewardOnMerge;
    }

    set rewardOnMerge(value) {
        this._rewardOnMerge = value;
    }

    get rewardTrack() {
        return this._rewardTrack;
    }

    set rewardTrack(value) {
        this._rewardTrack = value;
    }

    valid() {

        if (!this.key || this.key.length === 0) {
            return false;
        }

        if (!this.rewardOnMerge || !this.rewardOnMerge.valid() || this.rewardOnMerge.empty()) {
            return false;
        }

        if (!this.rewardTrack || !this.rewardTrack.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.rewardTrack || this.rewardTrack.empty();
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PiggyStageConfig());
        } else if (target instanceof PiggyStageConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PiggyStageConfig, {
    _name: alias("name", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _rewardOnMerge: alias("reward_merge", RewardModel.schema()),
    _rewardTrack: alias("reward_track", RewardTrack.schema())
})